import { render, staticRenderFns } from "./LoginTopNav.vue?vue&type=template&id=33abaa54&"
import script from "./LoginTopNav.vue?vue&type=script&lang=ts&"
export * from "./LoginTopNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports